import './InstallExtension.scss';
import ExtensionImg from '../../../../assets/settings/extension.png';
import ChromeButtonImg from '../../../../assets/settings/extension-button.png';
import { useTranslation } from 'react-i18next';

const InstallExtension = () => {
  const { t } = useTranslation();

  return (
    <div className="extension-container">
      <p className="extension-title">{t('settings.productHub.chromeExtension')}</p>
      <p className="extension-subtitle">{t('settings.productHub.extensionSubtitle')}</p>
      <div className="extension">
        <div className="extension-preview">
          <img
            src={ExtensionImg}
            alt={t('settings.productHub.extensionPreviewAlt')}
            draggable="false"
          />
        </div>
        <a
          href="https://chromewebstore.google.com/detail/lifestack-extension/mbpcaihbaecjnndomdpkigmmhdnfccjb"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={ChromeButtonImg}
            alt={t('settings.productHub.chromeWebStoreAlt')}
            draggable="false"
          />
        </a>
      </div>
    </div>
  );
};

export default InstallExtension;
